<template>
    <div class="container-fluid content-wrapper" v-if="purchaseOrder">
        <p-form @submit="onSubmit(false)" id="purchase-order-form" ref="purchaseOrderForm" v-on:deletePurchaseOrder="deletePurchaseOrder(this)">
            <b-row class="content-heading">
                <b-col>
                    <div >
                        {{ isNew ? 'Add' : 'Edit' }} Purchase Order
                    </div>
                </b-col>
                <b-col>
                    {{ isSingleRecord ? '' : `(${index + 1}/${this.ids.length})` }}
                </b-col>
            </b-row>
            <b-row class="pb-2" cols="2" cols-lg="12">
                <b-col>
                    <p-button :is-busy="isBusy"
                              v-if="!isSingleRecord"
                              @click="previous"
                              :disabled="first"
                              variant="outline-primary">&#8592; Previous</p-button>
                </b-col>
                <b-col class="text-end">
                    <p-button :is-busy="isBusy"
                              v-if="!isSingleRecord"
                              @click="next"
                              variant="outline-primary"
                              class="mb-2">
                        {{
                            showDoneButton ? 'Done' : `Next &#8594;`
                        }}
                    </p-button>
                </b-col>
            </b-row>
            <p-card>
                <PurchaseOrder :purchase-order="purchaseOrder"
                    ref="purchaseOrderComponent"
                    :is-busy='isBusy'
                    :is-new="isNew"
                    :form-is-dirty="formIsDirty"
                    @date-picker-initialized="e => {dataLoaded()}"
                    @deletePurchaseOrder="deletePurchaseOrder(purchaseOrder)"
                    @savePO="onSubmit(true)" />
            </p-card>
            <b-row>                
                <b-col class="mt-3 text-end">
                    <p-button variant="primary" type="submit" form="purchase-order-form" :is-busy="isBusy">Save</p-button>
                </b-col>
                <b-col class="mt-3 text-start">
                    <p-button :is-busy="isBusy"
                              v-if="!isSingleRecord"
                              @click="next"
                              variant="outline-primary"
                              class="mb-2">
                        {{
                            showDoneButton ? 'Done' : `Next &#8594;`
                        }}
                    </p-button>
                </b-col>


            </b-row>
        </p-form>
    </div>
</template>

<script>
import PurchaseOrder from './PurchaseOrder.vue';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import axios from 'axios';
import pricing from "@/services/PricingCalculations.js"
import editPage from '@/components/mixins/EditPage';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import { useAppStateStore } from '@/stores/appState.js';

export default {
    mixins: [NavigationGuard, editPage],
     props: {
        ids: {
             type: [Array],
            default() {
                return [];
            }
         },
    },
    data() {
        return {
            isBusy: false,
            purchaseOrder: null,
            afterLoad: false,
            index:0,
            isStatusChange: false
        };
    },
    watch: {
        purchaseOrder: NavigationGuard.$watcher
    },
    methods: {
        async onSubmit(isStatusChange) {
            this.isBusy = true;
            try {
                this.isStatusChange = isStatusChange;
                const statusFromClosedToOpen = this.purchaseOrder && this.purchaseOrder.originalStatus === 'Closed' && this.purchaseOrder.status !== 'Closed';
                // Validate the inner form on the PurchaseOrder component — that's where
                // the supplier and other fields actually live. The outer form has no fields.
                const innerForm = this.$refs.purchaseOrderComponent?.$refs?.purchaseOrderForm;
                if (!statusFromClosedToOpen && innerForm && !(await innerForm.validate())) {
                    this.$appError('Please correct the errors before saving.');
                    return;
                }
                await this.save();
            } finally {
                this.isBusy = false;
            }
        },
       async save() { 
            if (this.purchaseOrder.status != 'Proposed') {
                if (this.purchaseOrder.purchaseOrderDetails.length < 1) {
                    this.$appError(
                        'Purchase order must have at least one product added before saving'
                    );
                    return;
                }
            }
            if(!this.isStatusChange)
            {
                if (this.purchaseOrder.purchaseOrderDetails.every(x => (x.receivedQty + x.cancelQty) >= x.qty) && this.purchaseOrder.status !== 'Closed') {
                    if (this.purchaseOrder.purchaseOrderDetails.some(x => x.qty > 0) && !this.purchaseOrder.purchaseOrderDetails.some(x => x.backOrderQty > 0)) {
                        this.$appSuccess(`All products are recevied or cancelled successfully. Status is changed to closed`);
                        this.purchaseOrder.status = 'Closed';
                    }
                }
            }
            if (this.purchaseOrder.purchaseOrderDetails.some(i => i.qty === null)) {
                this.$appError(
                    'All products on the purchase order must have their qty set before saving'
                )
                return;
            }
            if (this.purchaseOrder.purchaseOrderDetails.some(i => i.cost === null)) {
                this.$appError(
                    'All products on the purchase order must have their cost set before saving'
                )
                return;
            }
            if (this.purchaseOrder.purchaseOrderDetails.some(i => i.margin === null)) {
                this.$appError(
                    'All products on the purchase order must have their margin set before saving'
                )
                return;
            }
            if (this.purchaseOrder.purchaseOrderDetails.some(i => i.retail === null)) {
                this.$appError(
                    'All products on the purchase order must have their retail set before saving'
                )
                return;
            }

            if (this.purchaseOrder.originalStatus == 'Open' && this.purchaseOrder.status == 'Proposed') {
                this.purchaseOrder.purchaseOrderDetails.forEach(x => { x.cancelQty = 0, x.receivedQty = 0 });
            }

            this.purchaseOrder.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
          
           let response = await axios.post('purchaseOrders', this.purchaseOrder);

                this.purchaseOrder = response.data;
                this.purchaseOrder.invoices.forEach((y) => {
                    y.invoiceDetails.forEach((x) => {
                        x.margin = pricing.computeMargin(x.cost, x.retail);
                        let pod = this.purchaseOrder.purchaseOrderDetails.find((p) => p.sku === x.sku && p.termId === x.termId && x.purchaseOrderId === this.purchaseOrder.purchaseOrderId );
                        if(pod){
                            x.purchaseOrderDetail = pod;
                            x.totalInvoicedQty = pod.receivedQty;
                        }
                    })});

                // Wait for the NavigationGuard watcher to fire on the purchaseOrder
                // reassignment above before clearing the dirty flag. Otherwise the
                // watcher would re-mark dirty after dataLoaded/dataSaved and the
                // router.push below would trigger the "leave without saving" prompt.
                await this.$nextTick();
                if (this.isNew) {
                    this.dataSaved();
                    this.$router.push("/purchaseorders/" + response.data.purchaseOrderId);
                } else {
                    // Clear the dirty flag synchronously (not via dataLoaded's deferred setTimeout).
                    // next()/previous() call router.push immediately after save() returns; the deferred
                    // reset loses the race, so the nav guard would see a stale dirty flag and fire a
                    // spurious "leave without saving" prompt.
                    this.dataSaved();
                }
                this.$appSuccess(`Purchase order '${this.purchaseOrder.poNumber}' saved successfully.`);
        },
        deletePurchaseOrder(purchaseOrder) {
            this.$bvModal
                .msgBoxConfirm(
                    'Are you sure you want to delete this Purchase Order?',
                    {
                        okTitle: 'Delete',
                        okVariant: 'danger'
                    }
                )
                .then(value => {
                    if (value) {
                        purchaseOrder.isBusy = true;
                        axios
                            .post('purchaseOrders/delete', {
                                purchaseOrderIds: [ purchaseOrder.purchaseOrderId ]
                            })
                            .then(() => {
                                this.dataSaved();
                                this.$router.push('/purchaseorders');
                                this.$appSuccess(`Purchase Order deleted successfully.`)
                            })
                            .finally(() => {
                                purchaseOrder.isBusy = false;
                            });
                    }
                });
        },
        loadData() {
            var purchaseOrderId = this.id;
            if (this.ids && this.ids.length) {
                purchaseOrderId = this.ids[this.index];
            }
            var locationId = useAppStateStore().getSelectedLocationId;
            let promise = this.isNew
                ? axios.get('purchaseOrders/new', { params: { locationId: locationId } })
                : axios.get('purchaseOrders', { params: { id: purchaseOrderId } });

            promise.then(resp => {
                this.purchaseOrder = resp.data;

                if (this.purchaseOrder.invoices != null && this.purchaseOrder.invoices.length > 0)
                {
                    this.purchaseOrder.invoices.forEach((i) => {
                        i.previousStatus = i.status;
                        i.invoiceDetails.forEach((x) => {
                            x.margin = pricing.computeMargin(x.cost, x.retail);
                        });
                        i.invoiceDetails.forEach((x) => {
                            let pod = this.purchaseOrder.purchaseOrderDetails.find((p) => p.sku === x.sku && p.termId === x.termId && x.purchaseOrderId === this.purchaseOrder.purchaseOrderId );

                            if(pod){
                                x.purchaseOrderDetail = pod;
                                x.totalInvoicedQty = pod.invoicedQty;
                            }
                        })
                    });
                }

               if (!this.isNew) {
                         this.dataLoaded();
                    }
                setTimeout(() => {
                    this.afterLoad = true;
                }, 500);
            });
        },
         next: async function() {
            this.isBusy = true;
            try {
                if (this.done) {
                    this.$router.push('/purchaseorders');
                    return;
                }
                try {
                    await this.save();
                } catch {
                    return;
                }
               this.index++;
                if (this.done) {
                    this.$router.push('/purchaseorders');
                    return;
                }
                this.$router.push({name: 'purchaseorders', params: {id : this.ids[this.index]}, query: {ids: this.ids.join(',')}});
            } finally {
                this.isBusy = false;
            }
        },
         previous: async function() {
            if (this.first) {
                return;
            }

            this.isBusy = true;
            try {
                try {
                    await this.save();
                } catch {
                    return;
                }
                this.index--;
                this.$router.push({name: 'purchaseorders', params: {id : this.ids[this.index]}, query: {ids: this.ids.join(',')}});
            } finally {
                this.isBusy = false;
            }
        },
    },
    mounted: function () {
        this.loadData();
        },

      computed: {
          done() {
            return !this.isSingleRecord && this.index === this.ids.length;
        },
          showDoneButton() {
            return !this.isSingleRecord && this.index === this.ids.length - 1;
        },
        first() {
            return this.index === 0;
        },
          isSingleRecord() {
              return !this.ids || this.ids.length <= 1;

        },
        },
    components: {
        PurchaseOrder
    }
};
</script>
